<div class="demo-centre">
  <div
    id="howdygo-embed"
    style="
      max-width: 2264px;
      background-color: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      box-shadow:
        0px 0px 1px rgba(45, 55, 72, 0.05),
        0px 4px 8px rgba(45, 55, 72, 0.1);"
  >
    <script src="https://js.howdygo.com/v1.2.1/index.js" ></script>
    <div
      id="howdygo-wrapper"
      style="position: relative;
      width: 100%;
      height: 0;
      padding-bottom: calc(52.120141342756185% + 40px);"
    >
      <iframe
        id="howdygo-frame"
        src="https://app.howdygo.com/embed/8a371747-6477-4c0b-997a-371495ebe510"
        frameborder="0"
        scrolling="no"
        allow="clipboard-write"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      ></iframe>

      @if (!showHowdyGo) {
        <div
          style="position: absolute;
                 top: -10px;
                 left: -10px;
                 width: calc(100% + 20px);
                 height: 40px;
                 background-color: white;
                 z-index: 10000;"
        >
        </div>
      }
    </div>
  </div>
</div>
